import React from 'react';
import './CustomDatePickerInput.scss';

class CustomDatePickerInput extends React.Component {

  focus() {   // eslint-disable-line
    // do nothing - this is here to stop react-datepicker from getting angry
  }

  render() {
    return (
      <div className="input-group custom-date-picker-input-group">
        <input
          type="text"
          {...this.props}
          className="form-control custom-date-picker-input"
          readOnly="true"
        />
        <i className="input-group-addon custom-date-picker-input-icon fa fa-calendar" />
      </div>
    );
  }
}

export default CustomDatePickerInput;



/** WEBPACK FOOTER **
 ** ./src/components/form/FormDatepicker/CustomDatePickerInput.js
 **/